import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { logoText } from 'assets/images';

import LanguageSwitcher from '../Languages';

import styles from './style.module.scss';

const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className={styles.navbar}>
      <div className={styles.frame}>
        <Link to="/">
          <div className={styles.logoDiv}>
            <img
              className={styles.apiLogo}
              alt="logo"
              src={logoText}
              loading="lazy"
            />
          </div>
        </Link>

        <Link to="/references" style={{ textDecoration: 'none' }}>
          <div
            className={clsx(
              styles.navbarReferences,
              location.pathname === '/references' && styles.active,
            )}>
            <div className={styles.navbarReferencesTitle}>
              {t('global:navbar.manual')}
            </div>
          </div>
        </Link>

        <Link to="/qr" style={{ textDecoration: 'none' }}>
          <div
            className={clsx(
              styles.navbarReferences,
              location.pathname === '/qr' && styles.active,
            )}>
            <div className={styles.navbarReferencesTitle}>{t('qr:header')}</div>
          </div>
        </Link>
      </div>

      <div>
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default Navbar;
